import { CiHeart } from "react-icons/ci";
import { MdPendingActions } from "react-icons/md";
import { FcShipped } from "react-icons/fc";
import React, { useState, useEffect } from "react";
import { LuPackageCheck } from "react-icons/lu";
import { GrDocumentMissing } from "react-icons/gr";
import { RiMoneyDollarCircleLine, RiAccountCircleFill, RiDeleteBack2Fill } from "react-icons/ri";
import { FaUserEdit } from "react-icons/fa";
import { ImAddressBook } from "react-icons/im";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import Ifnoprofilepicture from "../../public/ifnoprofilepicture.jpg"
import { DeleteAccountModal, DeletionReasonModal } from '../components/deletemodal';

const OverviewPage = () => {
  const [isUser, setIsUser] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [isDeletingAccount, setIsDeletingAccount] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("AficFreshuserDetails");
    if (user) {
      const parsedUser = JSON.parse(user);
      setIsUser(parsedUser);
    }
  }, []);

  const handleDeleteClick = () => {
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirm = () => {
    setShowDeleteConfirmation(false);
    setShowReasonModal(true);
  };

  const handleAccountDeletion = async (reason) => {
    setIsDeletingAccount(true);
    const loadingToast = toast.loading('Deleting account...');
  
    try {
      const token = localStorage.getItem('AficFreshtoken');
      await axios.post(
        "https://afric-fresh-backend.onrender.com/user/delete-account",
        { reason },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
  
      // Clear local storage
      localStorage.removeItem('AficFreshtoken');
      localStorage.removeItem('AficFreshuserDetails');
  
      toast.dismiss(loadingToast);
      toast.success('Account deleted successfully');
      
      // Redirect to home page
      navigate('/');
    } catch (error) {
      console.error('Error deleting account:', error);
      toast.dismiss(loadingToast);
      toast.error(error.response?.data?.message || 'Failed to delete account');
      setIsDeletingAccount(false);
    }
  };


  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

// Replace your current fetchUserData useEffect with this:
useEffect(() => {
  const fetchUserData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('AficFreshtoken');
      
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `https://afric-fresh-backend.onrender.com/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.data) {
        setUser(response.data);
        localStorage.setItem('AficFreshuserDetails', JSON.stringify(response.data));
      }
      
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error('Error fetching user data:', err);
    }
  };

  // Only fetch if we have a token and user isn't already loaded
  const token = localStorage.getItem('AficFreshtoken');
  if (token && !user) {
    fetchUserData();
  }
}, [user]); // Add user as dependency



  return (
    <div className="min-h-screen max-sm:mt-24 w-2/3 ml-10 max-sm:ml-0 max-sm:w-full">
      <Toaster position="top-right" />
      
      {/* Profile Section */}
      <section className="bg-white shadow p-4 max-sm:p-1 mb-4">
        <div className="flex items-center">
        {user?.profilepicture ? (
                    <div className="w-20 h-20 rounded-full overflow-hidden ring-4 ring-white shadow-lg animate-float">
                      <img 
                        src={user.profilepicture                       } 
                        alt="Profile"
                        className="w-full h-full object-cover rounded-full transform hover:scale-110 transition-transform duration-500"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.parentElement.innerHTML = `
                            <div class="w-full h-full bg-gray-100 flex items-center justify-center">
                              <span class="text-gray-400 text-sm">No Photo</span>
                            </div>`;
                        }}
                      />
                    </div>
                  ) : (
                    <div className="w-20 h-20 bg-gray-100 flex items-center justify-center ring-4 ring-white shadow-lg rounded-full animate-pulse-gentle">
                      <img src={Ifnoprofilepicture} className="w-20 h-20 rounded-full object-contain hover:scale-110 transition-transform duration-500" alt="Default Profile" />
                    </div>
                  )}
          <div className="ml-4">
            <h2 className="text-lg font-semibold uppercase">
              {isUser ? `${isUser.firstName} ${isUser.lastName}` : "Guest User"}
            </h2>
          </div>
        </div>

        <div className="flex items-center justify-between px-2 max-sm:p-0 mt-4 text-gray-600">
          <div className="hover:text-[#007D44] flex-col text-lg cursor-pointer">
            <Link to="/account/dashboard/profile" className="text-xl max-sm:text-lg text-center">
              <div className="flex justify-center items-center">
                <FaUserEdit size={39} />
              </div>
              Edit profile
            </Link>
          </div>

          <div className="hover:text-[#007D44] flex-col items-center justify-center cursor-pointer">
            <Link to="/account/dashboard/uploadepicture" className="text-xl text-center max-sm:text-lg">
              <div className="flex justify-center items-center">
                <RiAccountCircleFill size={39} />
              </div>
              Upload picture
            </Link>
          </div>

          <div className="hover:text-[#007D44] flex-col items-center justify-center cursor-pointer">
            <Link to="/account/dashboard/shippingdetails" className="text-center">
              <div className="flex justify-center items-center">
                <ImAddressBook size={39} />
              </div>
              Shipping Address
            </Link>
          </div>

          <div 
            className="hover:text-[#007D44] flex-col items-center justify-center cursor-pointer"
            onClick={handleDeleteClick}
          >
            <div className="flex justify-center items-center">
              <RiDeleteBack2Fill size={39} />
            </div>
            <p className="text-xl max-sm:text-lg text-center">Delete account</p>
          </div>
        </div>
      </section>

      {/* My Orders Section */}
      <section className="bg-white shadow p-4 mb-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">My Orders</h3>
          <Link to="/account/orders" className="text-gray-400 cursor-pointer hover:text-red-500">
            View All →
          </Link>
        </div>

        <div className="flex items-center justify-between text-center">
          <div className="cursor-pointer">
            <Link to="/account/orders" className="text-gray-400 cursor-pointer hover:text-[#007D44]">
              <div className="text-[#007D44] text-3xl flex justify-center items-center">
                <MdPendingActions size={50} />
              </div>
              Pending Order
            </Link>
          </div>
          <div className="cursor-pointer">
            <Link to="/account/orders" className="text-gray-400 cursor-pointer hover:text-[#007D44]">
              <div className="text-[#007D44] text-3xl flex justify-center items-center">
                <LuPackageCheck size={50} />
              </div>
              Ready For Delivery
            </Link>
          </div>
          <div className="cursor-pointer">
            <Link to="/account/orders" className="text-gray-400 cursor-pointer hover:text-[#007D44]">
              <div className="text-[#37ab77] text-3xl flex justify-center items-center">
                <FcShipped size={50} />
              </div>
              Delivered
            </Link>
          </div>
        </div>
      </section>

      {/* Delete Account Modals */}
      <DeleteAccountModal
        isOpen={showDeleteConfirmation}
        onClose={() => setShowDeleteConfirmation(false)}
        onConfirm={handleDeleteConfirm}
      />
      <DeletionReasonModal
        isOpen={showReasonModal}
        onClose={() => setShowReasonModal(false)}
        onSubmit={handleAccountDeletion}
        isLoading={isDeletingAccount}
      />
    </div>
  );
};

export default OverviewPage;